import actions from '../actions';
import urls from '../urls';
import constants from '../constants';
import { checkHttpStatus, parseJSON, commonHeaders } from '../utils';

export function getEmailEnterpriseMapApi(token) {
    const url =`${constants.LISTENER_API_URL}${urls.EMAIL_ENTERPRISES_MAP}`;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: "GET",
            headers: Object.assign({}, commonHeaders, {
                'Authorization': 'Bearer ' + token
            })
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((jsonResponse) => {
            resolve(jsonResponse.emailEnterpriseMap);
        })
        .catch(err => {
            console.error("There is an error getting email enterprises map !!", err);
            reject(err);
        });
    });
}

export function saveEmailEnterpriseMapApi(token, mapList) {
    const url =`${constants.LISTENER_API_URL}${urls.EMAIL_ENTERPRISES_MAP}`;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: "POST",
            headers: Object.assign({}, commonHeaders, {
                'Authorization': 'Bearer ' + token
            }),
            body: JSON.stringify({
                emailEnterpriseMap: mapList
            })
        })
        .then(checkHttpStatus)
        .then(() => {
            resolve();
        })
        .catch(err => {
            console.error("There is an error getting email enterprises map !!", err);
            reject(err);
        });
    });
}


// WEBPACK FOOTER //
// ./src/apis/emailEnterpriseMapApis.js